<template>
  <v-dialog v-model="internalDialog" max-width="1200px" persistent scrollable>
    <v-card>
      <v-card-title class="headline">
        <v-icon color="primary" left>mdi-clock-check</v-icon>
        Detalles de Marcaciones del {{ $fun.formatDateView(scheduleDate) }}
      </v-card-title>

      <v-card-text>
        <div
          v-if="!localMarkings || localMarkings.length === 0"
          style="text-align: center; color: #999; padding: 20px"
        >
          <v-icon large color="grey">mdi-information-outline</v-icon>
          <p>No hay detalles para mostrar</p>
        </div>

        <v-simple-table v-else dense>
          <thead>
            <tr>
              <th class="text-center">Tipo</th>
              <th class="text-center">Inicio Tomado(Marcación)</th>
              <th class="text-center">Fin Tomado(Marcación)</th>
              <th class="text-center">Horas</th>
              <th class="text-center">Reconsideración</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(detail, idx) in sortedMarkings"
              :key="
                detail.CacheDetailID ? detail.CacheDetailID + '-' + idx : idx
              "
            >
              <td class="text-center">
                <v-chip
                  :color="getMarkingColor(detail)"
                  text-color="white"
                  small
                >
                  <v-icon left small>{{ getMarkingIcon(detail) }}</v-icon>
                  {{ detail.DetailType }}
                </v-chip>
              </td>
              <td class="text-center">
                <!-- Chips de hora fin - Si es reconsideración, mostrar ambos -->
                <template v-if="detail.Reconsidered == 1">
                  <!-- Badge anterior tachado -->
                  <v-chip
                    :color="detail.BeginStatus == 'IE' ? 'red' : 'gray'"
                    :text-color="detail.BeginStatus == 'IE' ? 'white' : 'black'"
                    x-small
                    style="
                      text-decoration: line-through red;
                      margin-right: 4px;
                      opacity: 0.8;
                    "
                  >
                    {{
                      detail.BeginDateTime
                        ? formatDayHour(detail.BeginDateTime)
                        : "---"
                    }}
                  </v-chip>
                  <!-- Badge nuevo -->
                  <v-chip
                    :color="detail.EndStatus == 'IS' ? 'red' : 'gray'"
                    :text-color="detail.EndStatus == 'IS' ? 'white' : 'black'"
                    x-small
                  >
                    {{
                      detail.NewBeginDateTime
                        ? formatDayHour(detail.NewBeginDateTime)
                        : "---"
                    }}
                  </v-chip>
                </template>
                <!-- Si no es reconsideración, mostrar normal -->
                <template v-else>
                  <v-chip
                    :color="detail.BeginStatus == 'IE' ? 'red' : 'gray'"
                    :text-color="detail.BeginStatus == 'IE' ? 'white' : 'black'"
                    x-small
                  >
                    {{
                      detail.BeginDateTime
                        ? formatDayHour(detail.BeginDateTime)
                        : "---"
                    }}
                  </v-chip>
                </template>
              </td>
              <td class="text-center">
                <!-- Chips de hora fin - Si es reconsideración, mostrar ambos -->
                <template v-if="detail.Reconsidered == 1">
                  <!-- Badge anterior tachado -->
                  <v-chip
                    :color="detail.EndStatus == 'IS' ? 'red' : 'gray'"
                    :text-color="detail.EndStatus == 'IS' ? 'white' : 'black'"
                    x-small
                    style="
                      text-decoration: line-through red;
                      margin-right: 4px;
                      opacity: 0.8;
                    "
                  >
                    {{
                      detail.EndDateTime
                        ? formatDayHour(detail.EndDateTime)
                        : "---"
                    }}
                  </v-chip>
                  <!-- Badge nuevo -->
                  <v-chip
                    :color="detail.EndStatus == 'IS' ? 'red' : 'gray'"
                    :text-color="detail.EndStatus == 'IS' ? 'white' : 'black'"
                    x-small
                  >
                    {{
                      detail.NewEndDateTime
                        ? formatDayHour(detail.NewEndDateTime)
                        : "---"
                    }}
                  </v-chip>
                </template>
                <!-- Si no es reconsideración, mostrar normal -->
                <template v-else>
                  <v-chip
                    :color="detail.EndStatus == 'IS' ? 'red' : 'gray'"
                    :text-color="detail.EndStatus == 'IS' ? 'white' : 'black'"
                    x-small
                  >
                    {{
                      detail.EndDateTime
                        ? formatDayHour(detail.EndDateTime)
                        : "---"
                    }}
                  </v-chip>
                </template>
              </td>
              <td class="text-center">
                {{
                  floatNumber(
                    calculateHoursDifference(
                      detail.NewBeginDateTime,
                      detail.NewEndDateTime
                    )
                  )
                }}
              </td>
              <td class="text-center">
                <v-btn
                  v-if="
                    detail.BeginMarkingID != null && detail.EndMarkingID != null && detail.ValidationStatus == 2
                  "
                  icon
                  x-small
                  color="grey"
                  @click="$emit('open-reconsideration', detail)"
                  title="Solicitar reconsideración"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
          <!-- resta de LABOR Y REFRIGERIO -->
          <tfoot>
            <tr>
              <td colspan="3" class="text-right font-weight-bold">
                Total Laboral:
              </td>
              <td class="text-center font-weight-bold">
                {{ floatNumber(totalLaborHours) }}
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-right font-weight-bold">
                Total Refrigerio:
              </td>
              <td class="text-center font-weight-bold">
                {{ floatNumber(totalBreakHours) }}
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-right font-weight-bold">
                Total General:
              </td>
              <td class="text-center font-weight-bold">
                {{ floatNumber(totalGeneralHours) }}
              </td>
            </tr>
          </tfoot>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">
          <v-icon left>mdi-close</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "MarkingsByDateModal",
  props: {
    value: Boolean,
    markings: Array,
    headers: Array,
    scheduleDate: [String, Date],
    statusOptions: Array,
    scheduleData: Object, // 👈 NUEVO: datos del horario programado
  },
  data() {
    return {
      internalDialog: this.value,
      localMarkings: JSON.parse(JSON.stringify(this.markings || [])),
      markingStates: {
        LABOR: "LABORADO",
        REFRIGERIO: "REFRIGERIO",
      },
    };
  },
  computed: {
    sortedMarkings() {
      // Ordena los detalles por la fecha de inicio
      return [...this.localMarkings].sort(
        (a, b) => new Date(a.NewBeginDateTime) - new Date(b.NewBeginDateTime)
      );
    },

    laborMarkings() {
      return this.localMarkings.filter((m) => {
        const status = m.DetailType.trim(); // 👈 LIMPIAR ESPACIOS
        return status === "LABOR";
      });
    },

    breakMarkings() {
      return this.localMarkings.filter((m) => {
        const status = m.DetailType.trim(); // 👈 LIMPIAR ESPACIOS
        return status === "REFRIGERIO";
      });
    },
    totalLaborHours() {
      let HLaboral = 0;
      //horas laborales si solo hay 1 registro de LABOR
      if (this.laborMarkings.length === 1) {
        HLaboral = this.laborMarkings.reduce(
          (sum, m) => sum + (m.HoursCalculated || 0),
          0
        );
      } else {
        HLaboral = this.sortedMarkings.reduce(
          (sum, m) => sum + (m.HoursCalculated || 0),
          0
        );
      }
      return HLaboral;
    },
    totalBreakHours() {
      return this.breakMarkings.reduce(
        (sum, m) =>
          sum +
          (this.calculateHoursDifference(m.NewBeginDateTime, m.NewEndDateTime) || 0),
        0
      );
    },
    totalGeneralHours() {
      return this.totalLaborHours - this.totalBreakHours;
    },
  },
  watch: {
    value(val) {
      this.internalDialog = val;
      if (val) {
        this.localMarkings = JSON.parse(JSON.stringify(this.markings || []));
      }
    },
    internalDialog(val) {
      this.$emit("input", val);
    },
    markings(val) {
      this.localMarkings = JSON.parse(JSON.stringify(val || []));
    },
  },
  methods: {  
    refresh() {
      //console.log("actualizando marcaciones...");
      
    this.refreshMarkings();
  },
    formatDayHour(date) {
      if (!date) return "";
      const d = new Date(date);
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const dayName = days[d.getDay()];
      //const day = d.getDate().toString().padStart(2, "0");
      //const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");

      return `${dayName} : ${hours}:${minutes}:${seconds}`;
    },
    calculateHoursDifference(start, end) {
      if (!start || !end) {
        return 0;
      }
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffMs = endDate - startDate; // Diferencia en milisegundos
      if (isNaN(diffMs) || diffMs < 0) {
        return 0;
      }
      // Convertir milisegundos a horas
      return diffMs / 1000 / 60 / 60;
    },
    floatNumber(value) {
      return parseFloat(value).toFixed(2);
    },
    getMarkingIcon(marking) {
      const cleanStatus = marking.DetailType ? marking.DetailType.trim() : "";

      const iconMap = {
        LABOR: "mdi-login",
        REFRIGERIO: "mdi-coffee",
      };

      return iconMap[cleanStatus] || "mdi-clock";
    },

    getMarkingColor(marking, expectedType) {
      const cleanStatus = marking.DetailType ? marking.DetailType.trim() : "";

      // Colores base por tipo de marcación
      const colorMap = {
        LABOR: "green",
        REFRIGERIO: "deep-orange",
      };

      return colorMap[cleanStatus] || "grey";
    },

    close() {
      this.internalDialog = false;
    },
    async refreshMarkings() {
      //console.log("Refreshing markings for date:", this.scheduleDate);
      
      // Recarga los detalles de marcaciones desde el backend
      if (!this.scheduleDate || !this.$parent || !this.$parent.item) return;
      const cacheID = this.$parent.item.CacheID;
      const requestID = this.$fun.getUserID();
      // Llama al servicio que trae los detalles actualizados
      const res =
        await this.$parent.$options.components.sCrud.options.service.list(
          { CacheID: cacheID, ScheduleDate: this.scheduleDate },
          requestID
        );
      if (res && res.data && Array.isArray(res.data)) {
        // Busca el registro actual y actualiza los detalles
        const item = res.data.find(
          (x) => x.CacheID === cacheID && x.ScheduleDate === this.scheduleDate
        );
        if (item && item.Details) {
          this.localMarkings =
            typeof item.Details === "string"
              ? JSON.parse(item.Details)
              : item.Details;
        }
      }
    },
  },
};
</script>
